// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PQuestionOutlinedSvg from "@fishx/icons-svg/es/asn/PQuestionOutlined";
import FishxIcon from '../components/FishxIcon';

var PQuestionOutlined = function PQuestionOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PQuestionOutlinedSvg
  }));
};

PQuestionOutlined.displayName = 'PQuestionOutlined';
export default React.forwardRef(PQuestionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PQuestionOutlined.js
// module id = 3570
// module chunks = 0